<template>
  <div class="py-4 container-fluid">
    <!-- Operational Metrics Cards -->
    <div class="row mb-4">
      <div class="col-md-3 mb-3" v-for="card in topCards" :key="card.title">
        <div class="card shadow h-100">
          <div
            class="card-body d-flex justify-content-between align-items-center"
          >
            <div>
              <h6 class="text-muted">{{ card.title }}</h6>
              <h4>{{ card.value }}</h4>
            </div>
            <div>
              <i :class="card.icon" style="font-size: 1.5em"></i>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Charts Row -->
    <div class="row mb-4">
      <div class="col-md-6 mb-4">
        <div class="card shadow h-100">
          <div class="card-body">
            <h6 class="mb-3">Sessions This Week</h6>
            <canvas id="sessionsChart"></canvas>
          </div>
        </div>
      </div>
      <div class="col-md-6 mb-4">
        <div class="card shadow h-100">
          <div class="card-body">
            <h6 class="mb-3">Bed Occupancy Trend</h6>
            <canvas id="occupancyChart"></canvas>
          </div>
        </div>
      </div>
    </div>

    <!-- Important Summaries -->
    <div class="row">
      <div
        class="col-md-4 mb-3"
        v-for="summary in summaries"
        :key="summary.title"
      >
        <div class="card shadow h-100">
          <div
            class="card-body d-flex flex-column align-items-start justify-content-between"
          >
            <h6 class="text-muted">{{ summary.title }}</h6>
            <h4>{{ summary.value }}</h4>
          </div>
        </div>
      </div>
      <div class="col-md-9 mb-3">
        <div class="card shadow h-100">
          <div class="card-body">
            <h6 class="mb-3">Common Diagnoses</h6>
            <canvas style="max-height: 40vh" id="diagnosisChart"></canvas>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Chart from "chart.js/auto";

export default {
  name: "DialysisClinicDashboard",
  data() {
    return {
      topCards: [
        {
          title: "Revenue Raised Today",
          value: 28,
          icon: "fa fa-money text-primary",
        },
        {
          title: "Inventories Sold Today",
          value: 28,
          icon: "fa fa-sitemap text-primary",
        },
        {
          title: "Pending Invoices",
          value: 28,
          icon: "fa fa-file-o text-primary",
        },
        {
          title: "Active Patients Today",
          value: 28,
          icon: "fas fa-user-injured text-primary",
        },
        {
          title: "Sessions Completed Today",
          value: 46,
          icon: "fas fa-procedures text-success",
        },
        {
          title: "Available Slots This Week",
          value: 12,
          icon: "fas fa-calendar-check text-info",
        },
        {
          title: "Bed Occupancy Rate",
          value: "87%",
          icon: "fas fa-bed text-danger",
        },
        {
          title: "Scheduled Patients (7 Days)",
          value: 134,
          icon: "fas fa-users text-warning",
        },
      ],
      summaries: [
        { title: "Number of Dialysis Beds", value: 16 },
        { title: "Machines Functional", value: 14 },
        { title: "Sessions Missed This Week", value: 3 },
      ],
    };
  },
  mounted() {
    this.renderCharts();
  },
  methods: {
    renderCharts() {
      new Chart(document.getElementById("sessionsChart"), {
        type: "bar",
        data: {
          labels: ["Mon", "Tue", "Wed", "Thu", "Fri", "Sat", "Sun"],
          datasets: [
            {
              label: "Sessions",
              data: [18, 20, 17, 22, 19, 14, 16],
              backgroundColor: "#4e73df",
            },
          ],
        },
      });

      new Chart(document.getElementById("occupancyChart"), {
        type: "line",
        data: {
          labels: ["Mon", "Tue", "Wed", "Thu", "Fri", "Sat", "Sun"],
          datasets: [
            {
              label: "Occupancy %",
              data: [80, 85, 83, 90, 88, 82, 87],
              borderColor: "#1cc88a",
              fill: false,
            },
          ],
        },
      });

      new Chart(document.getElementById("diagnosisChart"), {
        type: "pie",
        data: {
          labels: ["ESRD", "AKI", "Others"],
          datasets: [
            {
              data: [70, 20, 10],
              backgroundColor: ["#36b9cc", "#f6c23e", "#e74a3b"],
            },
          ],
        },
      });
    },
  },
};
</script>

<style scoped>
.card h4 {
  font-size: 1.75rem;
  font-weight: 600;
}
</style>
